import React from 'react';
import Icon from 'components/AppIcon';

const SessionFilters = ({ filters, onFiltersChange, sessionCount }) => {
  const handleFilterChange = (key, value) => {
    onFiltersChange(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const clearFilters = () => {
    onFiltersChange({
      search: '',
      deviceType: 'all',
      location: 'all',
      status: 'all',
      timeRange: '24h'
    });
  };

  const hasActiveFilters = filters.search || 
    filters.deviceType !== 'all' || 
    filters.location !== 'all' || 
    filters.status !== 'all' || 
    filters.timeRange !== '24h';

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="font-medium text-text-primary">Фильтры и поиск</h3>
        <div className="flex items-center gap-4">
          <span className="text-sm text-text-secondary">
            Найдено сессий: <span className="font-medium text-text-primary">{sessionCount}</span>
          </span>
          {hasActiveFilters && (
            <button
              onClick={clearFilters}
              className="text-sm text-primary hover:text-primary-700 transition-colors duration-150"
            >
              Сбросить фильтры
            </button>
          )}
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
        {/* Search */}
        <div className="lg:col-span-2">
          <label className="block text-sm font-medium text-text-primary mb-2">
            Поиск
          </label>
          <div className="relative">
            <Icon 
              name="Search" 
              size={16} 
              className="absolute left-3 top-1/2 transform -translate-y-1/2 text-secondary-400" 
            />
            <input
              type="text"
              placeholder="Поиск по имени, email, IP..."
              name="admin-search"
              value={filters.search}
              onChange={(e) => handleFilterChange('search', e.target.value)}
              className="
                w-full pl-10 pr-4 py-2 border border-secondary-300 rounded-md
                focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary
                transition-all duration-150 text-sm
              "
            />
          </div>
        </div>

        {/* Device Type */}
        <div>
          <label className="block text-sm font-medium text-text-primary mb-2">
            Тип устройства
          </label>
          <select
            value={filters.deviceType}
            onChange={(e) => handleFilterChange('deviceType', e.target.value)}
            className="
              w-full px-3 py-2 border border-secondary-300 rounded-md
              focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary
              transition-all duration-150 text-sm bg-surface
            "
          >
            <option value="all">Все устройства</option>
            <option value="desktop">Компьютер</option>
            <option value="mobile">Мобильный</option>
            <option value="tablet">Планшет</option>
          </select>
        </div>

        {/* Status */}
        <div>
          <label className="block text-sm font-medium text-text-primary mb-2">
            Статус
          </label>
          <select
            value={filters.status}
            onChange={(e) => handleFilterChange('status', e.target.value)}
            className="
              w-full px-3 py-2 border border-secondary-300 rounded-md
              focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary
              transition-all duration-150 text-sm bg-surface
            "
          >
            <option value="all">Все статусы</option>
            <option value="active">Активные</option>
            <option value="idle">Неактивные</option>
            <option value="expired">Истекшие</option>
            <option value="suspicious">Подозрительные</option>
          </select>
        </div>

        {/* Time Range */}
        <div>
          <label className="block text-sm font-medium text-text-primary mb-2">
            Период времени
          </label>
          <select
            value={filters.timeRange}
            onChange={(e) => handleFilterChange('timeRange', e.target.value)}
            className="
              w-full px-3 py-2 border border-secondary-300 rounded-md
              focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary
              transition-all duration-150 text-sm bg-surface
            "
          >
            <option value="1h">Последний час</option>
            <option value="24h">Последние 24 часа</option>
            <option value="7d">Последние 7 дней</option>
            <option value="30d">Последние 30 дней</option>
            <option value="all">Все время</option>
          </select>
        </div>
      </div>

      {/* Quick Filters */}
      <div className="flex flex-wrap gap-2">
        <span className="text-sm font-medium text-text-secondary">Быстрые фильтры:</span>
        <button
          onClick={() => handleFilterChange('status', 'active')}
          className={`
            px-3 py-1 rounded-md text-xs font-medium transition-colors duration-150
            ${filters.status === 'active' ?'bg-success text-white' :'bg-success-100 text-success-700 hover:bg-success-200'
            }
          `}
        >
          Только активные
        </button>
        <button
          onClick={() => handleFilterChange('status', 'suspicious')}
          className={`
            px-3 py-1 rounded-md text-xs font-medium transition-colors duration-150
            ${filters.status === 'suspicious' ?'bg-error text-white' :'bg-error-100 text-error-700 hover:bg-error-200'
            }
          `}
        >
          Подозрительные
        </button>
        <button
          onClick={() => handleFilterChange('deviceType', 'mobile')}
          className={`
            px-3 py-1 rounded-md text-xs font-medium transition-colors duration-150
            ${filters.deviceType === 'mobile' ?'bg-accent text-white' :'bg-accent-100 text-accent-700 hover:bg-accent-200'
            }
          `}
        >
          Мобильные устройства
        </button>
        <button
          onClick={() => handleFilterChange('timeRange', '1h')}
          className={`
            px-3 py-1 rounded-md text-xs font-medium transition-colors duration-150
            ${filters.timeRange === '1h' ?'bg-primary text-white' :'bg-primary-100 text-primary-700 hover:bg-primary-200'
            }
          `}
        >
          Последний час
        </button>
      </div>

      {/* Active Filters Display */}
      {hasActiveFilters && (
        <div className="flex flex-wrap items-center gap-2 pt-2 border-t border-secondary-200">
          <span className="text-sm font-medium text-text-secondary">Активные фильтры:</span>
          
          {filters.search && (
            <span className="inline-flex items-center gap-1 px-2 py-1 bg-secondary-100 text-secondary-700 rounded-md text-xs">
              Поиск: "{filters.search}"
              <button
                onClick={() => handleFilterChange('search', '')}
                className="hover:text-secondary-900"
              >
                <Icon name="X" size={12} />
              </button>
            </span>
          )}

          {filters.deviceType !== 'all' && (
            <span className="inline-flex items-center gap-1 px-2 py-1 bg-secondary-100 text-secondary-700 rounded-md text-xs">
              Устройство: {filters.deviceType}
              <button
                onClick={() => handleFilterChange('deviceType', 'all')}
                className="hover:text-secondary-900"
              >
                <Icon name="X" size={12} />
              </button>
            </span>
          )}

          {filters.status !== 'all' && (
            <span className="inline-flex items-center gap-1 px-2 py-1 bg-secondary-100 text-secondary-700 rounded-md text-xs">
              Статус: {filters.status}
              <button
                onClick={() => handleFilterChange('status', 'all')}
                className="hover:text-secondary-900"
              >
                <Icon name="X" size={12} />
              </button>
            </span>
          )}

          {filters.timeRange !== '24h' && (
            <span className="inline-flex items-center gap-1 px-2 py-1 bg-secondary-100 text-secondary-700 rounded-md text-xs">
              Период: {filters.timeRange}
              <button
                onClick={() => handleFilterChange('timeRange', '24h')}
                className="hover:text-secondary-900"
              >
                <Icon name="X" size={12} />
              </button>
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default SessionFilters;